// Complete portfolio data for Rankify Dev
// Each project has a unique description based on its niche & industry
export const projects = [
  // ===================== HEALTHCARE =====================
  {
    name: "Caredom Store",
    slug: "caredom-store",
    url: "https://www.caredomstore.in/",
    domain: "caredomstore.in",
    categories: ["Healthcare", "E-commerce"],
    niche: "Healthcare & Medical Supplies",
    frontend: ["HTML", "CSS", "Bootstrap"],
    backend: ["WordPress"],
    otherSkills: ["Paid Theme"],
    type: "website",
    featured: true,
    description: "A full-stack medical supplies e-commerce portal delivering healthcare essentials to Indian households. Built on WordPress with a paid theme customized for HIPAA-conscious flows, product taxonomies, and fast checkout.",
  },
  {
    name: "Cizy Biocare",
    slug: "cizy-biocare",
    url: "https://cizybiocare.com/",
    domain: "cizybiocare.com",
    categories: ["Healthcare"],
    niche: "Healthcare & Pharmaceuticals",
    type: "website",
    description: "Corporate site for a pharmaceutical brand covering therapy divisions, molecule catalog and B2B enquiries - designed for regulatory clarity and pharma-industry credibility.",
  },
  {
    name: "Steroid Gear",
    slug: "steroid-gear",
    url: "https://steroidgear.org/",
    hideScreenshot: true,
    domain: "steroidgear.org",
    categories: ["Healthcare"],
    niche: "CBD",
    frontend: ["ReactJS"],
    backend: ["React Native"],
    type: "website",
    description: "A React-powered CBD & wellness marketplace featuring product bundles, dosage guides and educational content, engineered for regulated-market SEO and mobile-first browsing.",
  },
  {
    name: "Gunjan IVF World",
    slug: "gunjan-ivf-world",
    url: "https://www.gunjanivfworld.com/",
    domain: "gunjanivfworld.com",
    categories: ["Healthcare"],
    niche: "IVF & Fertility Clinic",
    type: "website",
    description: "A trust-first digital presence for an IVF & fertility hospital showcasing treatment pathways, doctor profiles and patient journeys - engineered for empathetic conversion.",
  },
  {
    name: "Gunnare Sias Hospital",
    slug: "gunnare-sias",
    url: "https://www.gunnaresiason.com/",
    domain: "gunnaresiason.com",
    categories: ["Healthcare"],
    niche: "Orthopedic & Joint Replacement Clinic",
    type: "website",
    description: "Orthopedic super-speciality clinic website with structured treatment pages for joint replacement, sports injuries and pain management. Optimized for local search and appointment leads.",
  },
  {
    name: "Pyser Optics",
    slug: "pyser-optics",
    url: "https://www.pyseroptics.com/",
    domain: "pyseroptics.com",
    categories: ["Healthcare"],
    niche: "Optical & Scientific Instruments",
    type: "website",
    description: "A precision-optics brand site covering scientific optical instruments - technical spec sheets, industrial applications and enquiry funnels for a UK-based B2B market.",
  },
  {
    name: "Aelicure Pharma",
    slug: "aelicure-pharma",
    url: "https://aelicurepharma.com/",
    domain: "aelicurepharma.com",
    categories: ["Healthcare"],
    niche: "Pharmaceutical Company",
    type: "website",
    description: "Pharmaceutical company website with product divisions, manufacturing capabilities and third-party manufacturing enquiry system built for pharma distributors.",
  },
  {
    name: "Apex Heart Institute",
    slug: "apex-heart-institute",
    url: "https://www.apexheart.in/",
    domain: "apexheart.in",
    categories: ["Healthcare"],
    niche: "Cardiology Hospital",
    type: "website",
    description: "Cardiology super-speciality hospital website featuring cardiac procedures, senior consultants and 24×7 emergency contact - engineered for rapid trust and appointment conversion.",
  },

  // ===================== E-COMMERCE =====================
  {
    name: "Household Rebate",
    slug: "household-rebate",
    url: "https://www.householdrebate.com/",
    domain: "householdrebate.com",
    categories: ["E-commerce"],
    niche: "Coupons & Deals",
    frontend: ["HTML", "CSS", "Bootstrap"],
    backend: ["WordPress"],
    otherSkills: ["Figma"],
    type: "website",
    description: "A US coupons & rebates aggregator surfacing daily household deals with category filters, expiring offers and cashback flows - designed from Figma to WordPress build.",
  },
  {
    name: "The Perfume",
    slug: "the-perfume",
    hideScreenshot: true,
    url: "https://www.theperfume.ca/",
    domain: "theperfume.ca",
    categories: ["E-commerce"],
    niche: "Beauty & Fragrance Store",
    type: "website",
    description: "Canadian fragrance boutique with curated designer perfume catalog, gender filters and gift-set merchandising for a premium beauty audience.",
  },
  {
    name: "Golden Drops",
    slug: "golden-drops",
    url: "https://goldendrops.ca/",
    domain: "goldendrops.ca",
    categories: ["E-commerce"],
    niche: "Indian Grocery Store",
    type: "website",
    description: "Canadian-Indian grocery e-store with fresh, frozen & pantry SKUs, delivery-zone logic and multilingual product taxonomy tuned for the diaspora shopper.",
  },
  {
    name: "Sage N Hide",
    slug: "sage-n-hide",
    url: "https://sagenhide.com/",
    domain: "sagenhide.com",
    categories: ["E-commerce"],
    niche: "Leather Fashion Products",
    type: "website",
    description: "Premium leather-fashion label site featuring wallets, bags and accessories - built for luxury storytelling with tactile visuals and international shipping.",
  },
  {
    name: "We Hatke",
    slug: "we-hatke",
    url: "https://wehatke.com/",
    hideScreenshot: true,
    domain: "wehatke.com",
    categories: ["E-commerce", "Lifestyle"],
    niche: "Online Shopping, News, Entertainment & Lifestyle",
    frontend: ["HTML", "CSS", "Bootstrap"],
    backend: ["Laravel"],
    type: "website",
    description: "A Laravel-powered multi-vertical portal blending e-commerce, entertainment and lifestyle news - modular content templates and category storefronts under one brand.",
  },
  {
    name: "Haruharu India",
    slug: "haruharu-india",
    url: "https://www.haruharuindia.com/",
    domain: "haruharuindia.com",
    categories: ["E-commerce"],
    niche: "Korean Skincare & Cosmetics",
    type: "website",
    description: "Indian storefront for a Korean skincare label - routine-based navigation, ingredient education and shade-first product discovery for the K-beauty audience.",
  },
  {
    name: "GoKraftly",
    slug: "gokraftly",
    url: "https://gokraftly.in/",
    hideScreenshot: true,
    domain: "gokraftly.in",
    categories: ["E-commerce"],
    niche: "Handicrafts, Marble Inlay & Artisan Products",
    type: "website",
    featured: true,
    description: "An artisan marketplace celebrating Indian marble inlay, brassware and handicrafts with story-driven product pages and craft-cluster attribution for global buyers.",
  },

  // ===================== BUSINESS & NONPROFIT =====================
  {
    name: "GDI Partners",
    slug: "gdi-partners",
    url: "https://www.gdipartners.in/",
    domain: "gdipartners.in",
    categories: ["Business & Nonprofit"],
    niche: "Business Consulting & Financial Services",
    frontend: ["HTML", "CSS", "Bootstrap"],
    backend: ["WordPress"],
    otherSkills: ["Figma"],
    type: "website",
    description: "Business advisory & financial-services firm site built from Figma to WordPress - service verticals, case studies and lead-magnet driven contact funnels.",
  },
  {
    name: "Red Ant Staffing",
    slug: "red-ant-staffing",
    url: "https://redantstaffing.com/",
    domain: "redantstaffing.com",
    categories: ["Business & Nonprofit"],
    niche: "Recruitment & Staffing",
    type: "website",
    description: "US staffing agency site with employer and job-seeker portals, industry-vertical hiring solutions and applicant-conversion optimised CTAs.",
  },
  {
    name: "Prime Hiring Network",
    slug: "prime-hiring-network",
    url: "https://primehiringnetwork.com/",
    domain: "primehiringnetwork.com",
    categories: ["Business & Nonprofit"],
    niche: "Recruitment & Staffing",
    type: "website",
    description: "Recruitment-network platform matching employers with talent across industries - built with clean job-board UX and dual-audience conversion flows.",
  },
  {
    name: "Downtown Mohali",
    slug: "downtown-mohali",
    url: "https://www.downtownmohali.com/",
    domain: "downtownmohali.com",
    categories: ["Business & Nonprofit"],
    niche: "Mohali Business Directory",
    type: "website",
    description: "A hyperlocal business directory for Mohali listing shops, restaurants and services - geo-filters, category taxonomy and business-owner enrolment.",
  },
  {
    name: "Uniting Our World",
    slug: "uniting-our-world",
    url: "http://unitingourworld.ca/",
    domain: "unitingourworld.ca",
    categories: ["Business & Nonprofit"],
    niche: "Community Organization",
    type: "website",
    description: "Canadian non-profit community platform highlighting cultural initiatives, events and inclusive-community programs with donation-ready structure.",
  },
  {
    name: "Saksham Welfare",
    slug: "saksham-welfare",
    url: "https://sakshamwelfare.com/",
    domain: "sakshamwelfare.com",
    categories: ["Business & Nonprofit"],
    niche: "Social Welfare Organization",
    type: "website",
    description: "Social-welfare foundation website surfacing programs, impact stories and volunteer engagement - designed to build donor trust and grassroots participation.",
  },

  // ===================== TECHNOLOGY =====================
  {
    name: "Affobe",
    slug: "affobe",
    url: "https://affobe.com/",
    domain: "affobe.com",
    categories: ["Technology", "Marketing"],
    niche: "Digital Marketing & IT Services",
    frontend: ["HTML", "CSS", "Bootstrap"],
    backend: ["Static"],
    type: "website",
    description: "Digital-marketing & IT-services agency website built as a lightning-fast static site - SEO-optimised service pages and portfolio-driven credibility.",
  },
  {
    name: "Dream Web India",
    slug: "dream-web-india",
    url: "https://dreamwebindia.com/",
    domain: "dreamwebindia.com",
    categories: ["Technology", "Marketing"],
    niche: "Web Development & Digital Marketing",
    frontend: ["HTML", "CSS", "Bootstrap"],
    backend: ["WordPress"],
    otherSkills: ["PSD"],
    type: "website",
    description: "Web-development & marketing agency site translated from PSD to WordPress - service verticals, portfolio grids and enquiry conversion tuned for SMB clients.",
  },
  {
    name: "Rezyt Internet",
    slug: "rezyt-internet",
    url: "https://www.rezytinternet.com/",
    domain: "rezytinternet.com",
    categories: ["Technology"],
    niche: "Internet Services & IT Solutions",
    frontend: ["React JS"],
    backend: ["JavaScript"],
    otherSkills: ["Figma"],
    type: "website",
    featured: true,
    description: "A React-JS marquee for an internet-services provider - plan comparators, coverage flows and IT-solutions storytelling designed end-to-end from Figma.",
  },
  {
    name: "MagiqBox",
    slug: "magiqbox",
    url: "https://magiqbox.com/",
    domain: "magiqbox.com",
    categories: ["Technology"],
    niche: "Digital Signage & Interactive Displays",
    type: "website",
    description: "Product website for interactive digital-signage displays with retail, hospitality and enterprise use-cases - spec pages and B2B lead capture.",
  },
  {
    name: "TechExcel",
    slug: "techexcel",
    url: "https://techexcel.in/",
    domain: "techexcel.in",
    categories: ["Technology"],
    niche: "Software Development & IT Services",
    type: "website",
    description: "Software-development firm site featuring service portfolio, tech stacks and industry solutions - engineered for enterprise-buyer credibility.",
  },
  {
    name: "Einnosys",
    slug: "einnosys",
    url: "https://www.einnosys.com/",
    domain: "einnosys.com",
    categories: ["Technology"],
    niche: "Software Development & IT Solutions",
    type: "website",
    description: "Enterprise IT-solutions consultancy site with vertical-wise offerings, case studies and technical-white-paper distribution flow.",
  },

  // ===================== MARKETING =====================
  {
    name: "Viral Zone Media",
    slug: "viral-zone-media",
    url: "https://viralzone.media/",
    domain: "viralzone.media",
    categories: ["Marketing"],
    niche: "Digital Marketing & Media",
    frontend: ["HTML", "CSS", "Bootstrap"],
    backend: ["Static"],
    otherSkills: ["PSD"],
    type: "website",
    description: "Digital-media & marketing agency site translated from PSD to static build - bold service storytelling, case-study reels and conversion-focused enquiries.",
  },
  {
    name: "BluGrain",
    slug: "blugrain",
    url: "https://blugrain.com/",
    domain: "blugrain.com",
    categories: ["Marketing"],
    niche: "Digital Marketing Agency",
    type: "website",
    description: "Digital-marketing agency portfolio site - SEO, paid-media and content services structured with lead-magnet CTAs for growth-stage brands.",
  },

  // ===================== EDUCATION =====================
  {
    name: "Oxford Kids",
    slug: "oxford-kids",
    url: "https://oxfordkids.co.in/",
    domain: "oxfordkids.co.in",
    categories: ["Education"],
    niche: "Preschool & Early Education",
    frontend: ["HTML", "CSS", "Bootstrap"],
    backend: ["WordPress"],
    otherSkills: ["Paid Theme"],
    type: "website",
    featured: true,
    description: "Preschool chain website with curriculum, campus tour, gallery and admission-enquiry funnel - parent-friendly WordPress build on a paid theme.",
  },
  {
    name: "Kiddtopia",
    slug: "kiddtopia",
    url: "https://www.kiddtopia.in/",
    domain: "kiddtopia.in",
    categories: ["Education"],
    niche: "Kids Learning & Education",
    type: "website",
    description: "Kids-learning brand website with age-tiered programs, activity showcases and admission flows built for delighted parents and curious children.",
  },
  {
    name: "eSaral",
    slug: "esaral",
    url: "https://www.esaral.com/",
    domain: "esaral.com",
    categories: ["Education"],
    niche: "EdTech & Online Learning",
    type: "website",
    description: "EdTech platform for JEE/NEET aspirants featuring course catalog, faculty introductions, live-class integration and student conversion funnels.",
  },
  {
    name: "Symbiosis",
    slug: "symbiosis-uk",
    url: "https://www.symbiosis.co.uk/",
    domain: "symbiosis.co.uk",
    categories: ["Education"],
    niche: "Overseas Education Consultancy",
    type: "website",
    description: "Overseas education consultancy site (UK) covering study destinations, university partners and end-to-end student counselling journeys.",
  },

  // ===================== TRAVEL & HOSPITALITY =====================
  {
    name: "Madhu Resorts",
    slug: "madhu-resorts",
    url: "https://madhuresorts.com/",
    domain: "madhuresorts.com",
    categories: ["Travel & Hospitality"],
    niche: "Resort & Hospitality",
    frontend: ["HTML", "CSS", "Bootstrap"],
    backend: ["WordPress"],
    type: "website",
    description: "Boutique resort website with room categories, gallery reels, amenity pages and enquiry-to-booking flow - designed to convert leisure travellers.",
  },

  // ===================== FOOD & BEVERAGE =====================
  {
    name: "Chaashni",
    slug: "chaashni",
    url: "https://chaashni.com/",
    domain: "chaashni.com",
    categories: ["Food & Beverage"],
    niche: "Sweets & Indian Desserts",
    type: "website",
    description: "Indian sweets & mithai brand website with seasonal collections, festive gifting bundles and store-locator functionality.",
  },
  {
    name: "Real Bakers",
    slug: "real-bakers",
    url: "https://realbakers.in/",
    domain: "realbakers.in",
    categories: ["Food & Beverage"],
    niche: "Bakery",
    type: "website",
    description: "Neighbourhood bakery website with menu categories, custom-cake ordering and delivery-zone information for cake-first celebrations.",
  },
  {
    name: "Sweet Retreat by Sonal",
    slug: "sweet-retreat-by-sonal",
    url: "https://sweetretreatbysonal.com/",
    domain: "sweetretreatbysonal.com",
    categories: ["Food & Beverage"],
    niche: "Bakery & Custom Cakes",
    type: "website",
    description: "Home-baker studio site specialising in bespoke cakes and celebration desserts - visual-first portfolio with enquiry-driven ordering.",
  },

  // ===================== HOME & REAL ESTATE =====================
  {
    name: "The House of Patterns",
    slug: "the-house-of-patterns",
    url: "https://www.thehouseofpatterns.com/",
    hideScreenshot: true,
    domain: "thehouseofpatterns.com",
    categories: ["Home & Real Estate"],
    niche: "Home Decor & Interior Design",
    frontend: ["HTML", "CSS", "Bootstrap"],
    backend: ["PHP"],
    otherSkills: ["Figma"],
    type: "website",
    featured: true,
    description: "Home-decor & interior-design brand site with pattern-driven visual storytelling, product collections and consultation booking - Figma-to-PHP build.",
  },
  {
    name: "Sparkle Freshness",
    slug: "sparkle-freshness",
    url: "https://sparklefreshness.com/",
    domain: "sparklefreshness.com",
    categories: ["Home & Real Estate"],
    niche: "Home Cleaning Services",
    frontend: ["HTML", "CSS", "Bootstrap"],
    backend: ["WordPress"],
    otherSkills: ["Figma"],
    type: "website",
    description: "Home-cleaning service website with service tiers, area coverage and quick-booking widget - designed from Figma to WordPress for local-service SEO.",
  },
  {
    name: "HR Moving",
    slug: "hr-moving",
    url: "https://hrmoving.ca/",
    domain: "hrmoving.ca",
    categories: ["Home & Real Estate"],
    niche: "Moving & Relocation Services",
    type: "website",
    description: "Canadian moving-services website with residential, commercial and long-haul packages, quote calculator and slot-booking capability.",
  },
  {
    name: "BC Rich Flooring",
    slug: "bc-rich-flooring",
    url: "https://bcrichflooring.ca",
    domain: "bcrichflooring.ca",
    categories: ["Home & Real Estate"],
    niche: "Flooring & Renovation",
    type: "website",
    description: "Flooring & renovation contractor site (Canada) with material catalogs, project galleries and estimator-driven lead generation.",
  },
  {
    name: "Golden Spaces",
    slug: "golden-spaces",
    url: "https://goldenspaces.in/",
    domain: "goldenspaces.in",
    categories: ["Home & Real Estate"],
    niche: "Real Estate Developer",
    type: "website",
    description: "Real-estate developer site featuring residential & commercial projects, floor plans, amenities and channel-partner enquiry management.",
  },
  {
    name: "Test Valley Windows",
    slug: "test-valley-windows",
    url: "https://www.testvalleywindows.co.uk/",
    domain: "testvalleywindows.co.uk",
    categories: ["Home & Real Estate"],
    niche: "Windows & Doors",
    type: "website",
    description: "UK windows & doors installer site with product ranges, energy-rating explainers and area-service pages tuned for local search dominance.",
  },

  // ===================== LIFESTYLE =====================
  {
    name: "The Karma Story",
    slug: "the-karma-story",
    hideScreenshot: true,
    url: "https://thekarmastory.com/",
    domain: "thekarmastory.com",
    categories: ["Lifestyle"],
    niche: "Lifestyle & Wellness",
    frontend: ["HTML", "CSS", "Bootstrap"],
    backend: ["WordPress"],
    type: "website",
    description: "Lifestyle & wellness blog-brand website with story-driven categories, mindful-living guides and community-building content flows.",
  },

  // ===================== ART & DESIGN =====================
  {
    name: "Dillustro Art",
    slug: "dillustro-art",
    url: "https://dillustroart.com/",
    domain: "dillustroart.com",
    categories: ["Art & Design"],
    niche: "Artwork & Creative Design",
    frontend: ["HTML", "CSS", "Bootstrap"],
    backend: ["WordPress"],
    type: "website",
    description: "Independent artist portfolio site featuring illustration series, commission enquiries and print-shop capability powered by WordPress.",
  },

  // ===================== MANUFACTURING =====================
  {
    name: "Mechnocraft",
    slug: "mechnocraft",
    url: "https://mechnocraft.com/",
    domain: "mechnocraft.com",
    categories: ["Manufacturing"],
    niche: "Engineering & Industrial Solutions",
    frontend: ["HTML", "CSS", "Bootstrap"],
    hideScreenshot: true,
    backend: ["WordPress"],
    otherSkills: ["Figma"],
    type: "website",
    featured: true,
    description: "Precision-engineering & industrial-solutions company site with capability pages, machinery specs and B2B enquiry flow - Figma-to-WordPress build.",
  },
  {
    name: "Accurate Gundrill",
    slug: "accurate-gundrill",
    url: "http://accurategundrill.com/",
    domain: "accurategundrill.com",
    categories: ["Manufacturing"],
    niche: "Precision Engineering",
    type: "website",
    description: "Precision-engineering firm specialising in gundrilling & deep-hole services - capability sheets, tolerances and industry-served pages.",
  },
  {
    name: "SEPL India",
    slug: "sepl-india",
    hideScreenshot: true,
    url: "https://sepl-india.com/",
    domain: "sepl-india.com",
    categories: ["Manufacturing"],
    niche: "Industrial Equipment & Engineering",
    type: "website",
    description: "Industrial equipment & engineering solutions provider website with product catalogs, industry verticals and dealer enquiry management.",
  },
  {
    name: "Gayatri Infra",
    slug: "gayatri-infra",
    url: "http://www.gayatriinfra.com/",
    domain: "gayatriinfra.com",
    categories: ["Manufacturing"],
    niche: "Infrastructure & Civil Construction",
    type: "website",
    description: "Infrastructure & civil-construction company site with project portfolio, capability statements and tender-response readiness.",
  },
  {
    name: "Delhi Cars",
    slug: "delhi-cars",
    url: "https://delhicars.net/",
    domain: "delhicars.net",
    categories: ["Manufacturing"],
    niche: "Car Rental & Taxi Services",
    type: "website",
    description: "Delhi-based car rental & taxi-services portal with fleet listings, city-tour packages and instant booking-enquiry integration.",
  },

  // ===================== AGRICULTURE =====================
  {
    name: "VM Crop Care",
    slug: "vm-crop-care",
    url: "http://vmcropcare.com/",
    domain: "vmcropcare.com",
    categories: ["Agriculture"],
    niche: "Crop Protection & Agro Chemicals",
    type: "website",
    description: "Crop-protection & agro-chemicals brand website with product ranges, crop-wise recommendations and dealer/farmer engagement flows.",
  },
  {
    name: "APMC Deesa",
    slug: "apmc-deesa",
    url: "https://www.apmcdeesa.com/",
    domain: "apmcdeesa.com",
    categories: ["Agriculture"],
    niche: "Agricultural Market Committee",
    type: "website",
    description: "Official Agricultural Market Committee website for Deesa - trader listings, mandi rates, notices and farmer service information.",
  },

  // ===================== UI/UX FIGMA DESIGNS =====================
  {
    name: "Bars UI Design",
    slug: "bars-ui-design",
    url: "https://www.figma.com/design/TC1MJJiAfEWXXsMUJT4gp4/01_bars%5B1%5D?node-id=0-1&p=f&t=aPasLtrksqo5EVMy-0",
    domain: "figma.com",
    categories: ["UI/UX Designs"],
    niche: "Bars & Nightlife App UI",
    type: "figma",
    platform: "Figma",
    description: "A nightlife & bars discovery mobile UI concept - search flows, venue detail screens and reservation UI designed in Figma with a bold late-night aesthetic.",
  },
  {
    name: "Pickleball App UI Design",
    slug: "pickleball-app-ui",
    url: "https://www.figma.com/design/46Quh5ppjHwQIyHnEeMpwT/pickleball-app-last?t=waycWcJ1k06Wtq95-0",
    domain: "figma.com",
    categories: ["UI/UX Designs"],
    niche: "Pickleball Sports App UI",
    type: "figma",
    platform: "Figma",
    description: "A pickleball community-app UI concept - player profiles, match scheduling, court discovery and leaderboards designed with a sport-first visual system.",
  },
  {
    name: "Grocery App UI Design",
    slug: "grocery-app-ui",
    url: "https://www.figma.com/design/1MhTA3MEmX38iN4c8xqiQL/Grocery-App-(Copy)?node-id=0-1&node-type=canvas&t=xxbh0k1vv1knVqlr-0",
    domain: "figma.com",
    categories: ["UI/UX Designs"],
    niche: "Grocery Delivery App UI",
    type: "figma",
    platform: "Figma",
    description: "A grocery-delivery mobile-app UI concept - category browsing, cart flows and delivery-slot UI with a fresh, appetite-driven visual style.",
  },

  // ===================== MOBILE APPLICATIONS =====================
  {
    name: "Tasam Solutions App",
    slug: "tasam-solutions-app",
    url: "https://play.google.com/store/apps/details?id=tasamsolutions.com&hl=en_IN",
    domain: "play.google.com",
    categories: ["Mobile Applications"],
    niche: "Business Utility App",
    type: "mobile-app",
    platform: "Android",
    description: "Business utility Android app on Google Play - service enquiries and customer engagement bundled into a lightweight native experience.",
  },
  {
    name: "DelhiCarz – Buy & Sell Used Cars",
    slug: "delhicarz-ios",
    url: "https://apps.apple.com/in/app/delhicarz-buy-sell-used-cars/id1598722163",
    domain: "apps.apple.com",
    categories: ["Mobile Applications"],
    niche: "Used-Car Marketplace",
    type: "mobile-app",
    platform: "iOS",
    description: "iOS marketplace app to buy & sell pre-owned cars in Delhi - listing flow, chat and dealer discovery, published on the App Store.",
  },
  {
    name: "Video Status Maker",
    slug: "video-status-maker",
    url: "https://play.google.com/store/apps/details?id=com.epic.videostatusmaker",
    domain: "play.google.com",
    categories: ["Mobile Applications"],
    niche: "Video Editor & Status App",
    type: "mobile-app",
    platform: "Android",
    description: "Android video-status maker app for creating short vertical clips with music, effects and quick share - live on Google Play.",
  },
  {
    name: "Max Earn App",
    slug: "max-earn-app",
    url: "https://play.google.com/store/apps/details?id=com.maxearnin",
    domain: "play.google.com",
    categories: ["Mobile Applications"],
    niche: "Rewards & Earning App",
    type: "mobile-app",
    platform: "Android",
    description: "Rewards & earning Android app packaging tasks, referrals and payouts into a mobile-first monetisation experience.",
  },
  {
    name: "Lakshya TV Channel",
    slug: "lakshya-tv-ios",
    url: "https://apps.apple.com/in/app/lakshya-tv-channel/id1131675439",
    domain: "apps.apple.com",
    categories: ["Mobile Applications"],
    niche: "Live TV & Streaming App",
    type: "mobile-app",
    platform: "iOS",
    description: "iOS app for Lakshya TV channel with live streaming, on-demand shows and channel news - distributed on the App Store.",
  },
  {
    name: "Cricket Fast Line",
    slug: "cricket-fast-line",
    url: "https://play.google.com/store/apps/details?id=cricket.fast.line&hl=en&gl=US",
    domain: "play.google.com",
    categories: ["Mobile Applications"],
    niche: "Live Cricket Score App",
    type: "mobile-app",
    platform: "Android",
    description: "Android live-cricket-score app delivering ball-by-ball updates, series schedules and player stats to fanatical fans.",
  },
];

// Category configuration for homepage display order
export const categoryConfig = [
  { key: "Healthcare", description: "Hospitals, clinics and medical brands built for empathy, trust and conversion." },
  { key: "E-commerce", description: "Storefronts engineered for browsing, discovery and frictionless checkout." },
  { key: "Business & Nonprofit", description: "Consulting firms, foundations and organisations shaping communities." },
  { key: "Technology", description: "IT services, SaaS and digital-signage brands optimised for enterprise trust." },
  { key: "Marketing", description: "Agencies telling their own growth story with conversion-first design." },
  { key: "Education", description: "Preschools, universities and EdTech platforms attracting curious minds." },
  { key: "Travel & Hospitality", description: "Resorts and hospitality brands designed to inspire the next getaway." },
  { key: "Food & Beverage", description: "Bakeries and dessert brands with an appetite-first visual language." },
  { key: "Home & Real Estate", description: "Home services, decor, realty and renovation brands driving local leads." },
  { key: "Lifestyle", description: "Wellness and lifestyle experiences told through story-first content." },
  { key: "Art & Design", description: "Independent creators showcasing artistry through digital portfolios." },
  { key: "Manufacturing", description: "Industrial, precision-engineering and automotive brands going digital." },
  { key: "Agriculture", description: "Agri-commerce, crop-care and mandi platforms rooted in rural reach." },
  { key: "UI/UX Designs", description: "Figma-native design explorations across mobile app product concepts." },
  { key: "Mobile Applications", description: "Native Android and iOS applications published on Play Store & App Store." },
];

// Filter categories for the portfolio page
export const filterCategories = [
  "All Projects",
  "Healthcare",
  "E-commerce",
  "Business & Nonprofit",
  "Technology",
  "Marketing",
  "Education",
  "Travel & Hospitality",
  "Food & Beverage",
  "Home & Real Estate",
  "Lifestyle",
  "Art & Design",
  "Manufacturing",
  "Agriculture",
  "UI/UX Designs",
  "Mobile Applications",
];

export const getProjectsByCategory = (category) =>
  projects.filter((p) => p.categories.includes(category));

export const getFeaturedProjects = () => projects.filter((p) => p.featured);

export const getCategoryCount = (category) => {
  if (category === "All Projects") return projects.length;
  return getProjectsByCategory(category).length;
};

export const websiteCount = projects.filter((p) => p.type === "website").length;
export const figmaCount = projects.filter((p) => p.type === "figma").length;
export const mobileCount = projects.filter((p) => p.type === "mobile-app").length;